<template lang="pug">
.payment-info-wrapper
  .content
    table(v-if="cancelInvoice")
      tbody
        tr.total
          td Gesamt-Stornopreis
          td(colspan="3").text-right {{cancelInvoice.totalPrice/100 | toCurrency}}
        tr.payed
          td Getätigte Zahlungen
          td(colspan="3").text-right {{payedSum + (newPayment.total ? newPayment.total / 100 : 0) | toCurrency}}
        tr.left-payment
          td Ausstehende Zahlung
          td(colspan="3").text-right {{leftPayedSum - (newPayment.total ? newPayment.total / 100 : 0) | toCurrency}}
    table(v-else)
      tbody
        tr(v-if="mode !== 'minimal'" v-for="row in booking.bookingItems")
          td {{ row.name }}
          td.text-right {{row.count}}x
          td.text-right {{row.price/100 | toCurrency}}
          td.text-right {{row.totalPrice/100 | toCurrency}}
        tr.total(v-if="mode !== 'minimal'" )
          td Gesamtpreis
          td(colspan="3").text-right {{contract.totalPrice/100 | toCurrency}}
        tr.blank-row(v-if="mode !== 'minimal'")
          td(colspan="4")
        tr.split(v-if="contract.totalDownPayment")
          td
            b-icon(v-if="payedSum*100 >= contract.totalDownPayment" icon="check" type="is-success")
            b-icon(v-else icon="close" type="is-danger")
            |Anzahlung bis {{formatDate(contract.downPaymentDueDate)}}
          td(colspan="3").text-right {{contract.totalDownPayment / 100 | toCurrency}}
        tr.split
          td
            b-icon(v-if="payedSum*100 >= contract.totalFinalPayment + contract.totalDownPayment" icon="check" type="is-success")
            b-icon(v-else icon="close" type="is-danger")
            |{{contract.totalDownPayment ? 'Restzahlung' : 'Gesamtzahlung'}} bis {{formatDate(contract.finalPaymentDueDate)}}
          td(colspan="3").text-right {{contract.totalFinalPayment / 100 | toCurrency}}
        tr.payed
          td Getätigte Zahlungen
          td(colspan="3").text-right {{payedSum + (newPayment.total ? newPayment.total / 100 : 0) | toCurrency}}
        tr.left-payment
          td Ausstehende Zahlung
          td(colspan="3").text-right {{leftPayedSum - (newPayment.total ? newPayment.total / 100 : 0) | toCurrency}}
</template>

<script>
import { DateTime } from "luxon";

export default {
  props: {
    mode: {
      type: String
    },
    booking: {
      type: Object
    },
    newPayment: {
      type: Object,
      default() {
        return {
          total: 0
        }
      }
    }
  },
  computed: {
    contract() {
      if (!this.booking || !this.booking.parentContract) return {};
      return this.booking.parentContract.contracts[this.booking.parentContract.contracts.length-1];
    },
    cancelInvoice() {
      if (!this.booking || !this.booking.cancelInvoices || this.booking.cancelInvoices.length === 0) return null;
      return this.booking.cancelInvoices[this.booking.cancelInvoices.length-1];
    },
    payedSum() {
      let totalPayed = 0;
      if (!this.booking || !this.booking.payments) return totalPayed;
      for (let i = 0; i < this.booking.payments.length; i += 1) {
        totalPayed += this.booking.payments[i].total;
      }
      return totalPayed/100;
    },
    leftPayedSum() {
      let totalPayed = 0;
      if (!this.booking || !this.booking.payments) return totalPayed;
      for (let i = 0; i < this.booking.payments.length; i += 1) {
        totalPayed += this.booking.payments[i].total;
      }
      let leftPayment = this.booking.parentContract.contracts[this.booking.parentContract.contracts.length-1].totalPrice - totalPayed;
      if (this.booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED_FINAL') {
        leftPayment = this.booking.cancelInvoices[this.booking.cancelInvoices.length-1].totalPrice - totalPayed;
      }
      return leftPayment/100;
    }
  },
  methods: {
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-info-wrapper {
  table {
    font-size: 16px;
    
      tr.total {
        font-weight: 600;
        border-top: solid 2px $black;
        // background-color: $primary;
        // color: white;
      }
      tr.split {
        font-weight: 500;
        background-color: $light;
        color: black;
      }
      tr.payed {
        font-weight: 500;
        background-color: $success;
        color: white;
      }
      tr.left-payment {
        font-weight: 500;
        background-color: $warning;
        color: black;
      }
      tr.avg {
        font-style: italic;
        color: $darkgray;
      }
    
    td {
      padding: 0em 0.75em;
    }
  }
}

.paid-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .paid {
    background-color: $success;
    height: 80px;
    width: 100px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    color: white;
    .p-headline {
      text-align: center;
      font-weight: 500;
      text-transform: uppercase;
      font-size: 0.8rem;
      margin: $xs-space 0;
    }
    .p-value {
      text-align: center;
      font-weight: 500;
      text-transform: uppercase;
      font-size: 1rem;
      margin: $xs-space 0;
    }
    &.not {
      background-color: $danger;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
    &.info {
      width: 224px;
      background-color: $dark;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }
}

.text-right {
  text-align: right;
}

.blank-row {
  height: 24px !important; /* overwrites any other rules */
  background-color: #FFFFFF;
}
</style>